
/**
 * Header collapsible menu 
 */
try {
  (function () {
    const accordionList = document.querySelectorAll("[data-accordion-wrapper]");
    for (const accordion of accordionList) {
      let maxLevel = 0; // 最深层级
      const groupList = accordion.querySelectorAll("[data-accordion-group]");
      // accordion click event
      for (const group of groupList) {
        const level = group.getAttribute("data-lv");
        if (level > maxLevel) {
          maxLevel = level; /// 更新最深层级
        }
        const tirgger = group.querySelector("[data-accordion-trigger]");
        tirgger.addEventListener("click", function () {
          const extension = group.querySelector("[data-accordion-extension]");
          const isActive = group.classList.contains("active");
          if (!extension) return;
          let offset = 0;
          if (isActive) {
            // 收缩
            offset = -1 * Number(extension.style.maxHeight.replace("px", ""));
            group.classList.remove("active");
            extension.style.maxHeight = "0px";
            closeChildrenGroups(group);
          } else {
            // 展开
            offset = extension.scrollHeight;
            group.classList.add("active");
            extension.style.maxHeight = extension.scrollHeight + "px";
            // 关闭其他同级的 group
            closeSiblingGroups(group);
          }
          // 更新父级所有 group 高度
          updateParentsGroupHeight(group.parentElement, offset);
        });

        // 使默认展开的项（class="active"）自动展开
        const isActive = group.classList.contains("active");
        if (isActive) {
          const extension = group.querySelector("[data-accordion-extension]");
          if (!extension) return;
          let offset = extension.scrollHeight;
          group.classList.add("active");
          extension.style.maxHeight = extension.scrollHeight + "px";
          // 更新父级所有 group 高度
          updateParentsGroupHeight(group.parentElement, offset);
        }
      }

      function updateAllGroupsHeight() {
        for (const group of groupList) {
          updateGroupHeight(group);
        }
      }

      window.addEventListener("resize", function () {
        updateAllGroupsHeight();
      });

      // window.addEventListener("DOMContentLoaded", function () {
      //   for (let i = maxLevel; i > 0; i--) {
      //     const groupList = accordion.querySelectorAll(`[data-accordion-group][data-lv="${i}"]`);
      //     for (const group of groupList) {
      //       updateParentsGroupHeight(group.parentElement, offset);
      //     }
      //   }
      // });
    }


    /**
     * 更新 Accordion group 的高度
     * @param {HTMLElement} group [data-accordion-group]
     */
    function updateGroupHeight(group) {
      if (!group) return;
      const extension = group.querySelector("[data-accordion-extension]");
      const isActive = group.classList.contains("active");
      if (!extension) return;
      if (isActive) {
        extension.style.maxHeight = extension.scrollHeight + "px";
      } else {
        extension.style.maxHeight = 0;
      }
    }

    /**
     * 更新父级所有 Accordion group 的高度，递归
     * @param {HTMLElement} parentGroup group.parentElement [data-accordion-group]
     * @param {Number} offset height offset, eg. -100, 100
     */
    function updateParentsGroupHeight(parentGroup, offset) {
      if (!parentGroup) return;
      const find = parentGroup.closest("[data-accordion-group]");
      if (!find) return;
      const extension = find.querySelector("[data-accordion-extension]");
      if (extension) {
        extension.style.maxHeight = Number(extension.style.maxHeight.replace("px", "")) + offset + "px";
      }
      // 递归
      if (find.parentElement) {
        updateParentsGroupHeight(find.parentElement, offset);
      }
    }

    /**
     * 关闭其他同级别的 Accordion group 
     * 同时关闭同级别的子项
     * @param {HTMLElement} group [data-accordion-group]
     */
    function closeSiblingGroups(group) {
      if (!group || !group.hasAttribute("data-accordion-group")) return;
      const children = group.parentElement.children;
      for (const siblingGroup of children) {
        if (siblingGroup == group) continue;
        // 关闭同级别 group
        if (siblingGroup.classList.contains("active")) siblingGroup.classList.remove("active");
        // 关闭同级别的子 group
        for (const childrenGroup of siblingGroup.querySelectorAll("[data-accordion-group].active")) {
          childrenGroup.classList.remove("active");
        }
        // 关闭同级别以及所有子展开内容
        const extensionList = siblingGroup.querySelectorAll("[data-accordion-extension]");
        for (const extension of extensionList) {
          if (extension) extension.style.maxHeight = 0;
        }
      }
    }

    /**
     * 关闭所有 Accordion group 子项
     * @param {HTMLElement} group [data-accordion-group]
     */
    function closeChildrenGroups(group) {
      if (!group) return;
      const childrenGroupList = group.querySelectorAll("[data-accordion-group]");
      const extensionList = group.querySelectorAll("[data-accordion-extension]");
      for (const group of childrenGroupList) {
        if (group.classList.contains("active")) group.classList.remove("active");
      }
      for (const extension of extensionList) {
        if (extension) extension.style.maxHeight = 0;
      }
    }
  })();
} catch (error) {
  console.error(error)
}
